export default function Contact() {
  return (
    <article className="mkt-page">
      <header className="mkt-hero">
        <h1>Contact Us</h1>
        <p>
          Questions about CareerMaster, your account, hiring, or soft-job
          engagements? Reach us at{" "}
          <a href="mailto:support@careermaster.com">support@careermaster.com</a>
          .
        </p>
      </header>
      <section className="mkt-section">
        <p>
          Include your registered email address so we can find your account
          quickly.
        </p>
      </section>
    </article>
  );
}
